module.exports = __webpack_public_path__ + "static/media/watch.6c5e3675.png";